// Import logo components
import { ReactComponent as TIBLogoBlue } from 'assets/images/logo/tib-logo-blue.svg';
import { ReactComponent as ReachRightAdsLogo } from 'assets/images/logo/reachrightads-logo-full.svg';
import { ReactComponent as ConquestDSPLogo } from 'assets/images/logo/conquest-dsp-logo-full.svg';
import { ReactComponent as ConquestDSPLogoPurple } from 'assets/images/logo/conquest-dsp-logo-purple-full.svg';

// Small Logo
import { ReactComponent as TIBLogoSmall } from 'assets/images/logo/tib-logo-blue-small.svg';
import { ReactComponent as ReachRightAdsLogoSmall } from 'assets/images/logo/reachrightads-logo.svg';
import { ReactComponent as ConquestDSPLogoSmall } from 'assets/images/logo/conquest-dsp-logo-small.svg';

// Logo for Login
import { ReactComponent as TIBLogoFull } from 'assets/images/logo/logo-full.svg';

export const BLUE_COLORS = {
  primaryLightest: '#e4f6ff',
  primaryLighter: '#b2e5ff',
  primaryMedium: '#168ab4',
  primaryStrong: '#0e86ac',
  primaryBase: '#126a8a',
  primaryDarkest: '#192637',
};

export const RED_COLORS = {
  primaryLightest: '#ffe4e4',
  primaryLighter: '#f0a8a8',
  primaryMedium: '#CD2929',
  primaryStrong: '#B41616',
  primaryBase: '#880808',
  primaryDarkest: '#212121',
};

export const PURPLE_COLORS = {
  primaryLightest: '#f5f5ff',
  primaryLighter: '#b5b8e3',
  primaryMedium: '#363A8E',
  primaryStrong: '#363A8E',
  primaryBase: '#4b4e8f',
  primaryDarkest: '#142137',
};

export const TENANT_NAME = {
  TIB: 'TIB',
  TBD: 'TBD',
  REACHRIGHTADS: 'REACHRIGHTADS',
  CONQUESTDSP: 'CONQUESTDSP',
};

export const TENANT_TEXT_MAPPING = {
  [TENANT_NAME.TIB]: {
    TENANT_NAME: 'Turn It Blue',
    TENANT_NAME_ADS: 'Turn It Blue Ads',
    TENANT_NAME_DIGITAL: 'Turn It Blue Digital',
    TENANT_NAME_LLC: 'Turn It Blue Digital LLC',
    TENANT_DOMAIN: 'turnitbluedigital',
    TENANT_SIGNOFF: 'Kate',
    TENANT_SHORT_NAME: 'TIB Ads',
  },
  [TENANT_NAME.REACHRIGHTADS]: {
    TENANT_NAME: 'Reach Right Ads',
    TENANT_NAME_ADS: 'Reach Right Ads',
    TENANT_NAME_DIGITAL: 'Reach Right Ads',
    TENANT_NAME_LLC: 'Reach Right Ads, LLC',
    TENANT_DOMAIN: 'reachrightads',
    TENANT_SIGNOFF: 'The Reach Right Ads Team',
    TENANT_SHORT_NAME: 'Reach Right Ads',
  },
  [TENANT_NAME.CONQUESTDSP]: {
    TENANT_NAME: 'Conquest Ads',
    TENANT_NAME_ADS: 'Conquest Ads',
    TENANT_NAME_DIGITAL: 'Conquest Ads',
    TENANT_NAME_LLC: 'Conquest DSP, LLC',
    TENANT_DOMAIN: 'conquestdsp',
    TENANT_SIGNOFF: 'The Conquest DSP Team',
    TENANT_SHORT_NAME: 'Conquest DSP',
  },
};

export const TENANT_CONFIG = {
  [TENANT_NAME.TIB]: {
    key: TENANT_NAME.TIB,
    name: 'Turn It Blue',
    branding: {
      ...BLUE_COLORS,
      logo: TIBLogoBlue,
      logoSmall: TIBLogoSmall,
      logoFull: TIBLogoFull,
      favicon: '/logo-small.svg',
    },
    errorCodes: {},
    languages: ['en'],
  },
  [TENANT_NAME.TBD]: {
    key: TENANT_NAME.TBD,
    name: 'TBD',
    branding: {
      ...PURPLE_COLORS,
      logo: ConquestDSPLogo,
      logoSmall: ConquestDSPLogoSmall,
      logoFull: ConquestDSPLogoPurple,
      favicon: '/conquest-dsp-logo.svg',
    },
    errorCodes: {},
    languages: ['en'],
  },
  [TENANT_NAME.REACHRIGHTADS]: {
    key: TENANT_NAME.REACHRIGHTADS,
    name: 'Reach Right Ads',
    branding: {
      ...RED_COLORS,
      logo: ReachRightAdsLogo,
      logoSmall: ReachRightAdsLogoSmall,
      logoFull: ReachRightAdsLogo,
      favicon: '/reachrightads-logo.svg',
    },
    errorCodes: {},
    languages: ['en'],
  },
  [TENANT_NAME.CONQUESTDSP]: {
    key: TENANT_NAME.CONQUESTDSP,
    name: 'Conquest DSP',
    branding: {
      ...PURPLE_COLORS,
      logo: ConquestDSPLogo,
      logoSmall: ConquestDSPLogoSmall,
      logoFull: ConquestDSPLogoPurple,
      favicon: '/conquest-dsp-logo.svg',
    },
    errorCodes: {},
    languages: ['en', 'fr'],
  },
};

export const getBrandByKey = (key) => TENANT_CONFIG[key];
export const getAllBrands = () => Object.values(TENANT_CONFIG);
export const getBrandKeys = () => Object.keys(TENANT_CONFIG);
